'use client';

import { createContext } from 'react';
import { OWCategoryPage } from '../interfaces/domain/ow-category-page.modal';

export type CategoryPageBasePath = 'apps' | 'browseByGame' | '';

export type TCategoryPageContext = {
  categoryPage: OWCategoryPage;
  basePath: CategoryPageBasePath
}

const CategoryPageContext = createContext<TCategoryPageContext>({
  categoryPage: null,
  basePath: '',
});

export default CategoryPageContext;
